import { QueryClient } from '@tanstack/react-query';

/**
 * 전역 QueryClientProvider에서 사용되는 QueryClient
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: false,
      retry: 0,
      useErrorBoundary: true,
      refetchOnMount: false,

      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
      useErrorBoundary: true,
    },
  },
});
